import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from "@angular/common/http";
import { map, Observable } from "rxjs";
import { Router } from "@angular/router";
import { CommonService } from "../services/common.service";

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private commonService: CommonService,
    private router:Router) {}
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const headersConfig = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Token':'WPkhTbWInThPNiQtZM2pkUCF+TTtt6rHLSPPAMFtxiAtV7xIfIJFT1LFGb3ncCgcDaIxzmpmifFcY4PaNI/X/A=='
    };
    
    // if (localStorage.getItem('super-user-token')) {
    //   const token = JSON.parse(localStorage.getItem('super-user-token')!);
    //   headersConfig['Authorization'] = `Bearer ${token}`;
    // }

    const request = req.clone({ setHeaders: headersConfig });
    return next.handle(request).pipe(
    map((res: any) => {
      if ( res?.body && res.body.access_token)
        this.commonService.refreshToken(res.body.access_token);
      return res;
    }),
    // catchError((error, caught) => {
    //   this.commonService.logout();
    //   window.alert("Your session has ended after exceeding allowed idle time so as to protect your data.");
    //  // location.reload();
    //   this.router.navigate(['/authentication/signin'])
    //   return of(error);
    // }) as any
     );
  }
}
